/* eslint-disable react/no-array-index-key */
import { experienceData } from '../data';

const Experience = () => (
  <div id="experience" className=" experience container portfolio_container">
    <h3>Experience</h3>
    <div className="experience_list">
      {experienceData.map((experience, index) => (
        <div className="experience_card" key={index}>
          <h4>{experience.role}</h4>
          <p>{experience.company}</p>
          <p>{experience.year}</p>
          <p>{experience.description}</p>
        </div>
      ))}
    </div>
  </div>
);
export default Experience;
